var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "city-map city-map--has-price-mode" }, [
    _c(
      "div",
      { staticClass: "city-map__map" },
      [
        _c("div", { staticClass: "city-map__toggle" }, [
          _c("span", { staticClass: "city-map__toggle-label-text" }, [
            _vm._v("\n        " + _vm._s(_vm.getToggleLabel()) + "\n      ")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isPriceMode,
                expression: "isPriceMode"
              }
            ],
            staticClass: "city-map__toggle-input",
            attrs: { id: "is-price-mode", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.isPriceMode)
                ? _vm._i(_vm.isPriceMode, null) > -1
                : _vm.isPriceMode
            },
            on: {
              change: function($event) {
                var $$a = _vm.isPriceMode,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isPriceMode = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isPriceMode = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isPriceMode = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c("label", {
            staticClass: "city-map__toggle-label",
            attrs: { for: "is-price-mode" }
          })
        ]),
        _vm._v(" "),
        _vm.unavailable
          ? _c(
              "div",
              { staticClass: "city-map__toggle city-map__toggle--available" },
              [
                _c("span", { staticClass: "city-map__toggle-label-text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.t("map.toggleLabelAvailable")) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.showUnavailable,
                      expression: "showUnavailable"
                    }
                  ],
                  staticClass: "city-map__toggle-input",
                  attrs: { id: "show-unavailable", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.showUnavailable)
                      ? _vm._i(_vm.showUnavailable, null) > -1
                      : _vm.showUnavailable
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.showUnavailable,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.showUnavailable = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.showUnavailable = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.showUnavailable = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", {
                  staticClass: "city-map__toggle-label",
                  attrs: { for: "show-unavailable" }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "GoogleMap",
          {
            attrs: { options: _vm.options },
            on: { init: _vm.onGoogleMapInit }
          },
          [
            _vm.isInitialized
              ? _vm._l(_vm.markers, function(marker) {
                  return _c("GoogleMarker", {
                    key: marker.id,
                    attrs: {
                      id: marker.id,
                      name: marker.name,
                      address: marker.address,
                      image: marker.image,
                      lat: marker.lat,
                      lng: marker.lng,
                      price: marker.price,
                      currency: marker.currency,
                      color: marker.color,
                      "is-available": marker.isAvailable,
                      "is-price-mode": _vm.isPriceMode,
                      "show-unavailable": _vm.showUnavailable,
                      events: ["click", "mouseover"]
                    },
                    on: { click: _vm.onMarkerClick, init: _vm.onMarkerInit }
                  })
                })
              : _vm._e()
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }